module.exports = __webpack_public_path__ + "static/media/apartment23.abaa2e76.jpg";